import {AxiosInstance} from "axios";
import AddressesWithGroups from "../model/address/AddressesWithGroups";
import DictionaryCache from "../helper/DictionaryCache";
import Address from "../model/address/Address";

export default class AddressApi {
	addressSummaryCache: DictionaryCache<AddressesWithGroups>;
	addressCache: DictionaryCache<Address>;

	constructor(public readonly axiosInstance: AxiosInstance,
		public readonly basePath: string = "/api/web/addresses") {
		this.addressSummaryCache = DictionaryCache.empty();
		this.addressCache = DictionaryCache.empty();
	}

	findAddressesByText(text: string, sessionToken?: string): Promise<AddressesWithGroups> {
		return new Promise((resolve, reject) => {
			const cachedData = !sessionToken && this.addressSummaryCache.get(text);
			if (cachedData && cachedData.isDefined)
				resolve(cachedData.get);
			else {
				const params: Record<string, string> = {text};
				if (sessionToken) params.sessionToken = sessionToken;
				this.axiosInstance.get(this.basePath, {params}).then(resp => {
					const data = AddressesWithGroups.fromJson(resp.data);
					if (!sessionToken) this.addressSummaryCache.store(text, data);
					resolve(data);
				}).catch(reject);
			}
		});
	}

	getFullAddress(addressId: string, sessionToken?: string): Promise<Address> {
		return new Promise((resolve, reject) => {
			const cachedData = !sessionToken && this.addressCache.get(addressId);
			if (cachedData && cachedData.isDefined)
				resolve(cachedData.get);
			else {
				const params: Record<string, string> = {};
				if (sessionToken) params.sessionToken = sessionToken;
				this.axiosInstance.get(encodeURI(`${this.basePath}/${addressId}`), {params}).then(resp => {
					const data = Address.fromJson(resp.data);
					this.addressCache.store(addressId, data);
					resolve(data);
				}).catch(reject);
			}
		});
	}
}
